module.exports = __webpack_public_path__ + "static/media/browser_extension.3846c242.svg";